export default __webpack_public_path__ + "static/media/reset-icon.7cacaf2d.svg";